import React, { useState } from "react";
import { GNavbar } from "../../components/pages/gallery/navbar/GNavbar";
import { MainGallery } from "../../components/pages/gallery/Gallery/MainGallery";
import './style.css';

export const Gallery = () => {
    const [searchTerm, setSearchTerm] = useState("");

    const handleSearchChange = (value) => {
        setSearchTerm(value);
    };

    return (      
        <>
        <GNavbar searchTerm={searchTerm} onSearchChange={handleSearchChange} />
        <MainGallery searchTerm={searchTerm} />
        </>
    );
}

export default Gallery;
